<template>
    <div class="">
        <el-page-header @back="goBack" :content="userType == '01' ? '个人认证' : '企业认证'"></el-page-header><br />
        <!-- <el-alert
        title="下方字段填写将直接影响用户模板的分类展示，请认真填写。"
        type="warning"
        show-icon
      >
      </el-alert> -->
        <div class="info_box">
            <div class="card_tit mb20">认证内容</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm"
                label-position="right">
                <el-form-item label="身份证正面" prop="cardHead">
                    <el-upload class="upload-demo" :show-file-list="false" accept="image/jpeg,image/png,image/gif"
                        :headers="headers" action="/api/common/upload" :before-upload="beforeUpload"
                        :on-success="(response) => handleIdCardFront(response, 4)">
                        <el-button type="primary">点击上传身份证正面</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="身份证正面图片" prop='cardHead' v-if="ruleForm.idCardFront != ''">
                    <div>
                        <img :src="ruleForm.idCardFront" alt="" width="100px" height="100px">
                    </div>
                </el-form-item>
                <el-form-item label="身份证背面" prop="cardBack">
                    <el-upload class="upload-demo" :show-file-list="false" accept="image/jpeg,image/png,image/gif"
                        :headers="headers" action="/api/common/upload" :before-upload="beforeUpload"
                        :on-success="(response) => handleIdCardBack(response, 4)">
                        <el-button type="primary">点击上传身份证背面</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="身份证背面图片" prop="cardBack" v-if="ruleForm.idCardBack != ''">
                    <div>
                        <img :src="ruleForm.idCardBack" alt="" width="100px" height="100px">
                    </div>
                </el-form-item>
                <el-form-item label="营业执照正面" prop="license" v-if="userType == '02'">
                    <el-upload class="upload-demo" :show-file-list="false" accept="image/jpeg,image/png,image/gif"
                        :headers="headers" action="/api/common/upload" :before-upload="beforeUpload"
                        :on-success="(response) => handleBusinessCard(response, 4)">
                        <el-button type="primary">营业执照正面</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="营业执照正面图片" prop="license" v-if="userType == '02' && ruleForm.businessCard != ''">
                    <div>
                        <img :src="ruleForm.businessCard" alt="" width="100px" height="100px">
                    </div>
                </el-form-item>
                <el-form-item label="身份证号" prop="userCode" v-if="userType == '01'">
                    <el-input style="width: 200px" v-model="ruleForm.userCode" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="userName">
                    <el-input style="width: 200px" v-model="ruleForm.userName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="企业统一信用代码" prop="companyCode" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyCode" placeholder="请输入企业统一信用代码"></el-input>
                </el-form-item>
                <el-form-item label="法人姓名" prop="companyLegal" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyLegal" placeholder="请输入法人姓名"></el-input>
                </el-form-item>
                <el-form-item label="法人身份证" prop="companyLegalCode" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyLegalCode" placeholder="法人身份证"></el-input>
                </el-form-item>
                <el-form-item label="企业联系人" prop="companyContact" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyContact" placeholder="请输入企业联系人"></el-input>
                </el-form-item>
                <el-form-item label="企业联系方式" prop="companyContactPhone" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyContactPhone"
                        placeholder="请输入企业联系方式"></el-input>
                </el-form-item>
                <el-form-item label="企业地址" prop="companyAddress" v-if="userType == '02'">
                    <el-input style="width: 200px" v-model="ruleForm.companyAddress" placeholder="请输入企业地址"></el-input>
                </el-form-item>
                <el-form-item label="银行账户名称" prop="bankAccountName">
                    <el-input style="width: 200px" v-model="ruleForm.bankAccountName"
                        placeholder="请输入银行账户名称"></el-input>
                </el-form-item>
              <el-form-item label="开户行名称" prop="bankAccountName">
                <el-input style="width: 200px" v-model="ruleForm.bankName"
                          placeholder="请输入开户行名称"></el-input>
              </el-form-item>
                <el-form-item label="银行账号" prop="bankNo">
                    <el-input style="width: 200px" v-model="ruleForm.bankNo" placeholder="请输入银行账号"></el-input>
                </el-form-item>
                <el-form-item label="银行预留手机号" prop="bankPhone">
                    <el-input style="width: 200px" v-model="ruleForm.bankPhone" placeholder="银行预留手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">立即保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>

import { realName, realNameInfo } from "@/utils/api";
var moment = require("moment");

export default {
    components: {},
    data() {
        return {
            userType: "01",
            isSave: false,
            communityList: [],
            ruleForm: {
                id: "",
                userCode: "",
                userName: "",
                companyCode: "",
                companyLegal: "",
                companyLegalCode: "",
                companyContact: "",
                companyContactPhone: "",
                companyAddress: "",
                bankAccountName: "",
                bankNo: "",
                bankName: "",
                bankPhone: "",
                idCardFront: "",
                idCardBack: "",
                businessCard: ""
            },
            rules: {
              templateClassName: [
                { required: true, message: "请填写类别名称", trigger: "blur" },
              ],
              userCode: [
                { required: true, message: "请输入身份证号", trigger: "blur" },
                {
                  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                  message: '请输入正确的证件号',
                  trigger: 'blur'
                }
              ],
              userName: [
                { required: true, message: "请输入姓名", trigger: "blur" },
              ],
              companyCode: [
                { required: true, message: "请输入企业统一信用代码", trigger: "blur" },
              ],
              companyLegal: [
                { required: true, message: "请输入法人姓名", trigger: "blur" },
              ],
              companyLegalCode: [
                { required: true, message: "请输入法人身份证", trigger: "blur" },
                {
                  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                  message: '请输入正确的证件号',
                  trigger: 'blur'
                }
              ],
              companyContact: [
                { required: true, message: "请输入企业联系人", trigger: "blur" },
              ],
              companyContactPhone: [
                { required: true, message: "请输入企业联系方式", trigger: "blur" },
                {
                  pattern: /^1[3456789]\d{9}$/,
                  message: '请输入正确的手机号',
                  trigger: 'blur'
                }
              ],
              companyAddress: [
                { required: true, message: "请输入企业地址", trigger: "blur" },
              ],
              bankAccountName: [
                { required: true, message: "请输入银行账户名称", trigger: "blur" },
              ],
              bankNo: [
                { required: true, message: "请输入银行账号", trigger: "blur" },
              ],
              bankPhone: [
                { required: true, message: "请输入银行预留手机号", trigger: "blur" },
                {
                  pattern: /^1[3456789]\d{9}$/,
                  message: '请输入正确的手机号',
                  trigger: 'blur'
                }
              ],

            },
            headers: {
                Authorization: "Bearer " + localStorage.token,
                'Access-Control-Allow-Origin': '*'
            },
        };
    },
    beforeRouteLeave(to, from, next) {
        if (!this.isSave) {
            this.$confirm("您还未保存信息，确定需要离开当前页面吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    next();
                })
                .catch(() => { });
        } else {
            next();
        }
    },
    mounted() {
        this.userType = localStorage.userType;
        this.getRealNameInfo();
    },
    computed: {},
    methods: {
        goBack() {
            this.$router.push({
                path: "/authenticationManagement",
            });
        },
        beforeUpload(uploadFile, uploadFiles) {

        },
        // 上传身份证正面
        handleIdCardFront(res, type) {
            console.log(res, type, "=======上传成功返回的数据");
            this.ruleForm.idCardFront = res.fileName
        },
        // 上传身份证北面
        handleIdCardBack(res, type) {
            console.log(res, type, "=======上传成功返回的数据");
            this.ruleForm.idCardBack = res.fileName
        },
        // 上传营业执照正面
        handleBusinessCard(res, type) {
            console.log(res, type, "=======上传成功返回的数据");
            this.ruleForm.businessCard = res.fileName
        },
        // 获取实名信息
        getRealNameInfo() {
            realNameInfo({ id: localStorage.userId }).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    if (res.data) {
                        this.ruleForm = res.data;
                    }
                }
            });
        },

        submitForm(formName) {
            if (!this.ruleForm.idCardFront) {
                this.$message.error("请上传身份证正面");
                return;
            }
            if (!this.ruleForm.idCardBack) {
                this.$message.error("请上传身份证反面");
                return;
            }
            if (this.userType == '02') {
              if (!this.ruleForm.businessCard) {
                this.$message.error("请上传营业执照");
                return;
              }
                if (!/^1[3456789]\d{9}$/.test(this.ruleForm.companyContactPhone)) {
                    this.$message.error("企业联系方式有误，请重填");
                    return;
                }

                if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(this.ruleForm.companyLegalCode)) {
                    this.$message.error("法人身份证有误，请重填");
                    return;
                }
            } else {
                if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(this.ruleForm.userCode)) {
                    this.$message.error("身份证有误，请重填");
                    return;
                }
            }

            if (!/^1[3456789]\d{9}$/.test(this.ruleForm.bankPhone)) {
                this.$message.error("银行预留手机号有误，请重填");
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.saveForm();
                } else {
                    return false;
                }
            });
        },
        async saveForm() {
            const loading = this.$loading({
                lock: true,
                text: "请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.5)",
            });
            this.ruleForm.token = localStorage.token;
            this.ruleForm.id = localStorage.userId;
            let res = await realName(this.ruleForm);
            console.log(res);
            if (res.code == 200) {
                this.isSave = true;
                this.$message.success("实名认证信息已提交!");
                setTimeout(() => {
                    this.$router.push({
                        path: "/authenticationManagement",
                    });
                }, 600);
            } else {
                this.$message.error(res.msg);
            }
            loading.close();
        },
    },
};
</script>

<style lang="scss" scoped></style>